import { StepConfig } from '../../shared/multistepFormComponents/types';

export type ICStepConfig = { stepName: ICStepName } & StepConfig;

export enum ICStepName {
  // D2C Steps
  Intro = 'Intro',
  RealEstate = 'RealEstate',
  RealEstateUsage = 'RealEstateUsage',
  LockType = 'LockType',
  LockManufacturer = 'LockManufacturer',
  EmergencyFeature = 'EmergencyFeature',
  CylinderType = 'CylinderType',
  CylinderOverlap = 'CylinderOverlap',
  KeyThickness = 'KeyThickness',
  KeyDimensions = 'KeyDimensions',
  KeyDistance = 'KeyDistance',
  DoorDirection = 'DoorDirection',
  DoorDistance3O = 'DoorDistance3O',
  DoorDistance35 = 'DoorDistance35',
  DoorDistance40 = 'DoorDistance40',
  CylinderExchangePossible = 'CylinderExchangePossible',
  OutsideCylinderLength = 'OutsideCylinderLength',
  InsideCylinderLength = 'InsideCylinderLength',
  B2CNotice = 'B2CNotice',
  Subscribe = 'Subscribe',
  FitWhoEnters = 'FitWhoEnters',
  FitAccessTypes = 'FitAccessTypes',
  Remote = 'Remote',
  D2CRecommendation = 'D2CRecommendation',

  // B2B Steps
  B2BProperties = 'B2BProperties',
  B2BRecommendation = 'B2BRecommendation',

  // US/Hermes steps
  IntroUS = 'IntroUS',
  SingleCylinderDeadboltUS = 'SingleCylinder',
  MultipleCylinderUS = 'MultipleCylinder',
  LockManufacturerUS = 'LockManufacturerUS',
  NonSupportedCylindersUS = 'NonSupportedCylinders',
  MoreCylindersUS = 'MoreCylindersUS',
  BadCompatibilityUS = 'USBadCompatibility',
  RestrictedCompatibilityUS = 'USRestrictedCompatibility',
  GoodCompatibilityUS = 'USGoodCompatibility',
  RestrictedUs = 'RestrictedUs',
  RestrictedUsEuro = 'RestrictedUsEuro',

  // Nordics steps
  CylinderTypeNordics = 'CylinderTypeNordics',
  NordicsInside = 'NordicsInside',
  LatchTypeNordics = 'LatchTypeNordics',

  // Compatibility
  GoodCompatibility = 'GoodCompatibility',
  RestrictedCompatibility = 'RestrictedCompatibility',
  RestrictedCompatibilityGoPro = 'RestrictedCompatibilityGoPro',
  RestrictedCompatibilityUltraGo = 'RestrictedCompatibilityUltraGo',
  RestrictedCompatibilityGo = 'RestrictedCompatibilityGo',
  RestrictedCompatibilityGoUK = 'RestrictedCompatibilityGoUK',
  RestrictedUltraCompatibility = 'RestrictedUltraCompatibility',
  RestrictedCompatibilityNordics = 'RestrictedCompatibilityNordics',
  BadCompatibility = 'BadCompatibility',
}

export enum ICQuestions {
  IC_SURVEY_INTRO = 'icSurvey_start',
  IC_SURVEY_REAL_ESTATE = 'icSurvey_realEstate',
  IC_SURVEY_REAL_ESTATE_USAGE = 'icSurvey_realEstateUsage',
  IC_SURVEY_LOCK_TYPE = 'icSurvey_lockType',
  IC_SURVEY_LOCK_MANUFACTURER = 'icSurvey_lockManufacturer',
  IC_SURVEY_CYLINDER_TYPE = 'icSurvey_cylinderType',
  IC_SURVEY_CYLINDER_OVERLAP = 'icSurvey_cylinderOverlap',
  IC_SURVEY_KEY_THICKNESS = 'icSurvey_keyThickness',
  IC_SURVEY_KEY_DIMENSIONS = 'icSurvey_keyDimensions',
  IC_SURVEY_EMERGENCY_FEATURE = 'icSurvey_emergencyFeature',
  IC_SURVEY_DOOR_DIRECTION = 'icSurvey_doorDirection',
  IC_SURVEY_DOOR_DISTANCE_30 = 'icSurvey_doorDistance30',
  IC_SURVEY_DOOR_DISTANCE_35 = 'icSurvey_doorDistance35',
  IC_SURVEY_DOOR_DISTANCE_40 = 'icSurvey_doorDistance40',
  IC_SURVEY_CYLINDER_EXCHANGE_POSSIBLE = 'icSurvey_cylinderExchangePossible',
  IC_SURVEY_OUTSIDE_CYLINDER_LENGTH = 'icSurvey_outsideCylinderLength',
  IC_SURVEY_INSIDE_CYLINDER_LENGTH = 'icSurvey_insideCylinderLength',

  IC_SURVEY_KEY_DISTANCE = 'icSurvey_keyDistance',
  IC_SURVEY_SUBSCRIBE = 'icSurvey_subscribe',
  IC_SURVEY_GET_RESULTS = 'icSurvey_getResults',

  IC_SURVEY_FIT_WHO_ENTERS = 'icSurvey_fitWhoEnters',
  IC_SURVEY_FIT_ACCESS_TYPES = 'icSurvey_fitAccessTypes',

  IC_SURVEY_REMOTE = 'icSurvey_remote',

  IC_SURVEY_D2C_RECOMMENDATION = 'icSurvey_d2cRecommendation',
  IC_SURVEY_D2C_RECOMMENDATION_ACTION = 'icSurvey_d2cRecommendationAction',
  IC_SURVEY_B2B_PROPERTIES = 'icSurvey_b2bProperties',
  IC_SURVEY_B2B_RECOMMENDATION = 'icSurvey_b2bRecommendation',
  IC_SURVEY_B2B_RECOMMENDATION_ACTION = 'icSurvey_b2bRecommendationAction',

  // US
  IC_SURVEY_US_START = 'icSurveyUS_start',
  IC_SURVEY_US_SINGLE_CYLINDER = 'icSurveyUS_singleCylinder',
  IC_SURVEY_US_MULTIPLE_CYLINDERS = 'icSurveyUS_multipleCylinders',
  IC_SURVEY_US_LOCK_MANUFACTURER = 'icSurveyUS_lockManufacturer',
  IC_SURVEY_US_NON_SUPPORTED_CYLINDERS = 'icSurveyUS_nonSupportedCylinders',
  IC_SURVEY_US_MORE_CYLINDERS = 'icSurveyUS_moreCylinders',
  IC_SURVEY_US_NOT_COMPATIBLE = 'icSurveyUS_compatibility_bad',
  IC_SURVEY_US_NUKI_CLUB_SUBSCRIBE = 'icSurveyUS_subscribe',
  IC_SURVEY_US_NUKI_COMPATIBILITY_FULL = 'icSurveyUS_compatibility_full',
  IC_SURVEY_US_NUKI_COMPATIBILITY_RESTRICTED_SINGLE = 'icSurveyUS_compatibility_restricted_single',
  IC_SURVEY_US_GET_RESULTS = 'icSurveyUS_getResults',
  IC_SURVEY_RESTRICTED_US = 'icSurvey_restrictedUs',
  IC_SURVEY_RESTRICTED_US_EURO = 'icSurvey_restrictedUsEuro',

  // Nordics
  IC_SURVEY_CYLINDER_TYPE_NORDICS = 'icSurvey_cylinderTypeNordics',
  IC_SURVEY_NORDICS_INSIDE = 'icSurvey_nordicsInside',
  IC_SURVEY_LATCH_TYPE_NORDICS = 'icSurvey_nordicsLatchType',

  // Compatibility
  IC_SURVEY_GOOD_COMPATIBILITY = 'icSurvey_goodCompatibility',
  IC_SURVEY_RESTRICTED_COMPATIBILITY_ULTRA = 'icSurvey_restrictedCompatibilityUltra',
  IC_SURVEY_RESTRICTED_COMPATIBILITY_ULTRA_GO = 'icSurvey_restrictedCompatibilityUltraGo',
  IC_SURVEY_RESTRICTED_COMPATIBILITY_GO = 'icSurvey_restrictedCompatibilityGo',
  IC_SURVEY_RESTRICTED_COMPATIBILITY_GO_UK = 'icSurvey_restrictedCompatibilityGoUK',
  IC_SURVEY_RESTRICTED_COMPATIBILITY_GO_PRO = 'icSurvey_restrictedCompatibilityGoPro',
  IC_SURVEY_RESTRICTED_COMPATIBILITY_NORDICS = 'icSurvey_restrictedCompatibilityNordics',
  IC_SURVEY_BAD_COMPATIBILITY = 'icSurvey_badCompatibility',
}

export enum IntroAnswer {
  START = 'start',
}

export enum RealEstateAnswer {
  HOUSE = 'house',
  APARTMENT = 'apartment',
}

export enum RealEstateUsageAnswer {
  PRIVATE = 'privateResidence',
  SHORT_RENTAL = 'vacationRental',
}

export enum LockTypeAnswer {
  KNOB = 'knob',
  KEY = 'key',
}

export enum LockManufacturerAnswer {
  ABUS = 'abus',
  EVVA = 'evva',
  DOM = 'dom',
  DORMAKABA = 'dormakaba',
  KESO = 'keso',
  NEMEF = 'nemef',
  YALE = 'yale',
  MAUER = 'mauer',
  OTHER = 'other',
}
export enum EmergencyFeatureAnswer {
  YES = 'yes',
  NO = 'no',
}

export enum CylinderTypeAnswer {
  EURO = 'euro',
  SWISS = 'swiss',
  UK_OVAL = 'uk-oval',
  NORDIC = 'nordic',
  OTHER = 'other',
}

export enum CylinderOverlapAnswer {
  UP_TO_3 = 'upTo3',
  OVER_3 = 'over3',
}

export enum KeyThicknessAnswer {
  GREATER_4 = 'greater4',
  THINNER_4 = 'thinner4',
}

export enum KeyDimensionsAnswer {
  YES = 'yes',
  NO = 'no',
}

export enum DoorDirectionAnswer {
  INWARDS = 'inwards',
  OUTWARDS = 'outwards',
}

export enum DoorDistanceAnswer30 {
  YES = 'yes',
  NO = 'no',
}

export enum DoorDistanceAnswer35 {
  YES = 'yes',
  NO = 'no',
}

export enum DoorDistanceAnswer40 {
  YES = 'yes',
  NO = 'no',
}

export enum CylinderExchangePossibleAnswer {
  YES = 'yes',
  NO = 'no',
}

export enum KeyDistanceAnswer {
  MORE_37 = 'more37',
  LESS_37 = 'less37',
}

export enum SubscribeAnswer {
  SUBSCRIBE = 'subscribe',
  SKIP = 'skip',
}

export enum Compatibility {
  GOOD = 'good',
  BAD = 'bad',
  RESTRICTED = 'restricted',
}

export enum GoodCompatibilityAnswer {
  CONTINUE = 'goodContinue',
  GO_TO_SHOP = 'goodGoToShop',
}

export enum RestrictedCompatibilityAnswer {
  CONTINUE = 'restrictedContinue',
  GO_TO_SHOP = 'restrictedGoToShop',
}

export enum RestrictedCompatibilityUltraAnswer {
  CONTINUE = 'restrictedUltraContinue',
  GO_TO_SHOP = 'restrictedUltraGoToShop',
}

export enum BadCompatibilityAnswer {
  GO_TO_SHOP = 'badGoToShop',
  FIND_PRO_PARTNER = 'findProPartner',
  START_OVER = 'startOverAgain',
}

export enum FitWhoEntersAnswer {
  MYSELF = 'myself',
  PARTNER = 'partner',
  FAMILY = 'family',
  HOUSEHOLD = 'household',
  DELIVERY = 'delivery',
  SKIP = 'skip',
}

export enum FitAccessTypesAnswer {
  SMARTPHONE = 'smartphone',
  KEYPAD = 'keypad',
  FINGERPRINT = 'fingerprint',
  BLUETOOTH = 'bluetooth',
  SMART_ASSISTANTS = 'smartAssistants',
  SKIP = 'skip',
}

export enum RemoteAnswer {
  YES = 'yes',
  NO = 'no',
}

export enum D2CRecommendationAnswer {
  SL4 = 'SL4',
  SL4P = 'SL4P',
  HOME_SET_PRO = 'homeSetPro',
  HOME_SET = 'homeSet',
}

export enum D2CRecommendationActionAnswer {
  CLICK_SL4 = 'clickSL4',
  CLICK_SL4P = 'clickSL4P',
  CLICK_HOME_SET_PRO = 'clickHomeSetPro',
  CLICK_HOME_SET = 'clickHomeSet',
}

export enum B2BPropertiesAnswer {
  LESS_50 = 'shsB2c',
  MORE_50 = 'shsB2b',
  SKIP = 'skip',
}

export enum B2BRecommendationAnswer {
  SHS_SET = 'shsSet',
}

export enum B2BRecommendationActionAnswer {
  CLICK_SHS_SET = 'clickShsSet',
}

export type ICFormAnswers = {
  icSurvey_intro?: IntroAnswer;
  icSurvey_realEstate?: RealEstateAnswer;
  icSurvey_realEstateUsage?: RealEstateUsageAnswer;
  icSurvey_lockType?: LockTypeAnswer;
  icSurvey_lockManufacturer?: LockManufacturerAnswer;
  icSurvey_cylinderType?: CylinderTypeAnswer;
  icSurvey_emergencyFeature?: EmergencyFeatureAnswer;
  icSurvey_cylinderOverlap?: CylinderOverlapAnswer;
  icSurvey_doorDirection?: DoorDirectionAnswer;
  icSurvey_doorDistance30?: DoorDistanceAnswer30;
  icSurvey_doorDistance35?: DoorDistanceAnswer35;
  icSurvey_doorDistance40?: DoorDistanceAnswer40;
  icSurvey_cylinderExchangePossible?: CylinderExchangePossibleAnswer;
  icSurvey_outsideCylinderLength?: string;
  icSurvey_insideCylinderLength?: string;
  icSurvey_keyDistance?: KeyDistanceAnswer;
  icSurvey_keyThickness?: KeyThicknessAnswer;
  icSurvey_keyDimensions?: KeyDimensionsAnswer;
  icSurvey_subscribe?: SubscribeAnswer;
  icSurvey_goodCompatibility?: GoodCompatibilityAnswer;
  icSurvey_restrictedCompatibility?: RestrictedCompatibilityAnswer;
  icSurvey_restrictedCompatibilityUltra?: RestrictedCompatibilityUltraAnswer;
  icSurvey_badCompatibility?: BadCompatibilityAnswer;
  icSurvey_fitWhoEnters?: FitWhoEntersAnswer[];
  icSurvey_fitAccessTypes?: FitAccessTypesAnswer[];
  icSurvey_remote?: RemoteAnswer;
  icSurvey_d2cRecommendation?: D2CRecommendationAnswer;
  icSurvey_d2cRecommendationAction?: D2CRecommendationActionAnswer;
  icSurvey_b2bProperties?: B2BPropertiesAnswer;
  icSurvey_b2bRecommendation?: B2BRecommendationAnswer;
  icSurvey_b2bRecommendationAction?: B2BRecommendationActionAnswer;

  // Hermes
  icSurveyUS_singleCylinder?: 'yes' | 'no';
  icSurveyUS_multipleCylinders?: 'yes' | 'no';
  icSurveyUS_lockManufacturer?: USLockManufacturerAnswer;
  icSurveyUS_nonSupportedCylinders?: NonSupportedCylindersAnswer;
  icSurveyUS_moreCylinders?: MoreCylindersUSAnswer;

  // Nordics
  icSurvey_cylinderTypeNordics?: CylinderTypeNordicsAnswer;
  icSurvey_nordicsInside?: NordicsInsideAnswer;
  icSurvey_nordicsLatchType?: LatchTypeNordicsAnswer;
};

export enum CylinderTypeNordicsAnswer {
  EURO = 'euro',
  NORDIC_ROUND = 'nordic-round',
  SCANDIC_OVAL = 'scandi-oval',
  OTHER = 'nordics-other',
}

export enum NordicsInsideAnswer {
  KEY = 'key',
  THUMBTURN = 'thumbturn',
  COMBINED = 'combined',
  OTHER = 'other',
}

export enum LatchTypeNordicsAnswer {
  DEADBOLT = 'deadbolt',
  NO_DEADBOLT = 'noDeadbolt',
}

export enum IntroAnswerUS {
  START = 'start',
}

export enum USGoodCompatibilityAnswer {
  CONTINUE = 'findOutMore',
  GO_TO_SHOP = 'goToShop',
}

export enum USRestrictedCompatibilityAnswer {
  FIND_OUT_MORE = 'findOutMore',
  GO_TO_SHOP = 'goToShop',
}

export enum USBadCompatibilityAnswer {
  GO_TO_SHOP = 'goToShop',
  START_OVER = 'startOver',
}

export enum NonSupportedCylindersAnswer {
  DOUBLE_CYLINDER = 'doubleCylinder',
  MORTISE = 'mortiseLock',
  RIM = 'rimLock',
  OTHER = 'other',
}

export enum MoreCylindersUSAnswer {
  DOUBLE_CYLINDER = 'doubleCylinder',
  MORTISE_LOCK = 'mortiseLock',
  EURO = 'euro',
  OTHER = 'other',
}

export enum USLockManufacturerAnswer {
  ARROW_HARDWARE = 'ArrowHardware',
  ASHLEY_NORTON = 'AshleyNorton',
  BALDWIN = 'Baldwin',
  CALLAN = 'Callan',
  DEFIANT = 'Defiant',
  DELANEY = 'Delaney',
  EMTEK = 'Emtek',
  EZ_SET = 'EZSet',
  FAULTLESS = 'Faultless',
  GATEHOUSE = 'Gatehouse',
  GLOBAL_DOOR_CONTROLS = 'GlobalDoorControls',
  GRANDEUR = 'Grandeur',
  HAGER = 'Hager',
  KWIKSET = 'Kwikset',
  MAX_GRADE = 'MaxGrade',
  OMNIA_INDUSTRIES = 'OmniaIndustries',
  SCHLAGE = 'Schlage',
  STANLEY = 'Stanley',
  TOLEDO_FINE_LOCKS = 'ToledoFineLocks',
  WEISER = 'Weiser',
  WESLOCK = 'Weslock',
  YALE = 'Yale',
  OTHER = 'other',
}

export type ICSurveyStep = {
  surveyId: string;
  newICSurvey: boolean;
  question: string;
  answer: string;
};

export enum Limitations {
  restrictedEmergency = 'restrictedEmergency',
  restrictedKnob = 'restrictedKnob',
  restrictedKey = 'restrictedKey',
  restrictedCh = 'restrictedCh',
  restrictedChPro = 'restrictedChPro',
  restrictedOvalGo = 'restrictedOvalGo',
  restrictedOvalPro = 'restrictedOvalPro',
  restrictedCylinderLength = 'restrictedCylinderLength',
  restrictedMultipleCylinderDeadbolts = 'restrictedMultipleCylinderDeadbolts',
}
